'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _messages = require('../common/messages');

var _adapters = require('./adapters');

var validate = function validate(definition, eventKey, eventProperties, onError) {
  if (!definition || (typeof definition === 'undefined' ? 'undefined' : _typeof(definition)) !== 'object') {
    onError((0, _messages.eventError)('Invalid event key. The event definition for "' + eventKey + '" is undefined. Check your events.yaml dictionary.'));
  }

  if (definition) {
    (0, _adapters.deriveEventPropertySchema)(definition).validate(eventProperties, 'Event "' + eventKey + '"', onError);
  }
};

var create = exports.create = function create(definitions, caller) {
  var parsedDefinitions = (0, _adapters.normalizeDefinitions)(definitions, caller);

  return {
    definitions: parsedDefinitions,
    lookup: function lookup(_ref, eventKey, eventProperties) {
      var logError = _ref.logError,
          onError = _ref.onError;

      var definition = parsedDefinitions[eventKey];
      var hasErrors = void 0;

      validate(definition, eventKey, eventProperties, function (err) {
        hasErrors = true;
        onError(err);
        logError(err);
      });

      if (hasErrors) {
        return null;
      }

      return definition;
    }
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.70/js/dictionary/index.js
// module id = 391
// module chunks = 0